<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormNotifiacionConfig" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Menu</label>
							<input type="text" v-model="objNotificacionConfig.Menu" class="form-control" id="Menu" placeholder="Ingresar Menu" />
							<CValidation v-if="this.errorvalidacion.Menu" :Mensaje="'*'+errorvalidacion.Menu[0]"/>
						</div>
					</div>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
export default {
    name: 'FormNotificacionConfig',
    props: ['poBtnSave'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objNotificacionConfig: {
				IdNotificacionConfig: 0,
				Menu: '',
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods: {
        async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objNotificacionConfig.IdNotificacionConfig == 0) {
				await this.$http.post(
					'notificacionesConfig',this.objNotificacionConfig
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'notificacionesConfig/'+this.objNotificacionConfig.IdNotificacionConfig,
					this.objNotificacionConfig
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
        EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar()
        {
            this.$http.get(
                "notificacionesConfig/"+this.objNotificacionConfig.IdNotificacionConfig
            ).then((res) => {
                this.objNotificacionConfig = res.data.data;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objNotificacionConfig = {
				IdNotificacionConfig: 0,
				Menu: ''
            }
            this.errorvalidacion = [];
        },
    },
    created() {
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objNotificacionConfig.IdNotificacionConfig = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    },
}
</script>

<style>

</style>